import EditNotification from './EditNotification';

export default EditNotification;
